import { Provider, observer } from 'mobx-react';
import { Route } from 'react-router-dom';
import { Router } from 'react-router';
import { syncHistoryWithStore } from 'mobx-react-router';
import { configure } from 'mobx';
import PropTypes from 'prop-types';
import React from 'react';

import * as stores from '../store/stores';

import Configuracao from '../util/Configuracao';
import ErrorBoundary from './share/ErrorBoundary';
import MensagemSnackbar from './share/MensagemSnackbar';
import MensagemAlert from './share/MensagemAlert';

import Login from './Login';
import MenuAppBar from './menuapp/MenuAppBar';
import PageContent from './PageContent';

import { withStyles } from '@material-ui/core/styles';
import createBrowserHistory from 'history/createBrowserHistory';

const axios = require('axios');
const browserHistory = createBrowserHistory();

const history = syncHistoryWithStore(browserHistory, stores.routerStore);

const styles = () => ({
  root: {
    display: 'flex',
  },
});

@observer
class App extends React.Component {
  constructor () {
    super();
    this.configurarMobx();
    this.configurarAxios();
    this.configurarAmbiente();
  }
  configurarMobx () {
    configure({// Configuração do mobx para forçar (fiscalizar) o uso de 'action' nas funções que alteram o estado da aplicação
      enforceActions: 'observed'
    });
  }

  configurarAxios () {
    axios.defaults.timeout = Configuracao.DEFAULT_AXIOS_TIMEOUT;
    axios.defaults.headers.common['Accept'] = '*/*';
    axios.interceptors.request.use(this.requestInterceptorHandler, this.requestInterceptorErrorHandler);
    axios.interceptors.response.use(this.responseInterceptorHandler, this.responseInterceptorErrorHandler);
  }

  requestInterceptorHandler = (config) => {
    return config;
  }

  requestInterceptorErrorHandler = (error) => {
    stores.errorStore.registrarErro(error);
    return Promise.reject(error);
  }

  responseInterceptorHandler = (response) => {
    return response;
  }

  responseInterceptorErrorHandler = (error) => {
    this.tratarRespostaErro(error);
    return Promise.reject(error);
  }

  handleLogoffOnError = () => {
    stores.usuarioStore.realizarLogoff();
    stores.routerStore.push('/');
  }

  tratarRespostaErro (error) {
    if (error.response && (error.response.status === 401 && history.location.pathname !== '/')) {
      stores.usuarioStore.saveLocationOnError(history.location.pathname);
      stores.alertStore.abrirAlert('Ops..',
        'Sua sessão expirou. ' +
        'Você será redirecionado para página de login.',
        this.handleLogoffOnError);
    } else if (error.response && (error.response.status === 403 && history.location.pathname !== '/')) {
      stores.usuarioStore.saveLocationOnError(history.location.pathname);
      stores.alertStore.abrirAlert('Ops..',
        'Você não tem permissão para acessar este recurso. ' +
        'Você será redirecionado para página de login.',
        this.handleLogoffOnError);
    } else {
      console.error(error);
      stores.errorStore.registrarErro(error, error + '\n' + JSON.stringify(error.response));
    }
  }

  configurarAmbiente = async () => {
    let config = {};
    if (process.env.NODE_ENV === 'local') {
      config = {
        'domain': process.env.SSO_COOKIE_DOMAIN,
        'sso': process.env.SSO,
        'api': process.env.API
      };
    } else {
      const response = await fetch('./ambiente.json');
      config = response.ok ? await response.json() : {};
    }

    Configuracao.getConfiguracao().ambiente = config;
  }

  render () {
    const { classes } = this.props;
    return (
      <Provider {...stores}>
        <Router history={history}>
          {!stores.usuarioStore.isUsuarioLogado
            ? <div>
              <Route path='/' exact component={Login} />
            </div>
            : <div className={classes.root}>
              <ErrorBoundary history={history}>
                <MenuAppBar />
                <PageContent />
                <MensagemAlert />
                <MensagemSnackbar />
              </ErrorBoundary>
            </div>
          }
        </Router>
      </Provider>
    );
  }
}
App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
